<template>
  <div class="">
    <login-form v-if="showLogin" />
    <div v-else class="">
      <div
        v-if="defaultButtons.includes('download')"
        class="bg-white rounded-full text-center py-2 w-3/4 m-auto mt-10 shadow-lg flex items-center justify-center gap-2"
        @click="handleGoToDownload"
      >
        <c-icon name="FileDownloadOutlined" size="1.2rem" />
        {{ $t("download-pass") }}
      </div>
      <div
        v-if="defaultButtons.includes('profile')"
        class="bg-white rounded-full text-center py-2 w-3/4 m-auto mt-10 shadow-lg flex items-center justify-center gap-2"
        @click="handleGoToProfile"
      >
        <c-icon name="AccountCircleRound" size="1.2rem" />
        {{ $t("view-profile") }}
      </div>
      <div
        v-if="defaultButtons.includes('signup')"
        class="bg-white rounded-full text-center py-2 w-3/4 m-auto mt-40 shadow-lg flex items-center justify-center gap-2"
        @click="handleGoToCreateCustomer"
      >
        <c-icon name="PersonAddRound" size="1.2rem" />
        {{ $t("create-new-account") }}
      </div>
      <div
        v-if="defaultButtons.includes('login')"
        class="bg-white rounded-full text-center py-2 w-3/4 m-auto mt-10 shadow-lg flex items-center justify-center gap-2"
        @click="showLogin = true"
      >
        <c-icon name="PersonFilled" size="1.2rem" />
        {{ $t("have-account") }}
      </div>
      <div
        v-if="defaultButtons.includes('continueWithoutSignup')"
        class="bg-white rounded-full text-center py-2 w-3/4 m-auto mt-10 shadow-lg flex items-center justify-center gap-2"
        @click="handleContinueWithoutSignup"
      >
        <c-icon name="ArrowForwardRound" size="1.2rem" />
        {{ $t("dont-want-add-points") }}
      </div>
      <div
        v-if="defaultButtons.includes('appointments')"
        class="bg-white rounded-full text-center py-2 w-3/4 m-auto mt-10 shadow-lg flex items-center justify-center gap-2"
        @click="
          $router.push({
            name: 'appointmentPage',
            params: { ...$route.params },
          })
        "
      >
        <c-icon name="CalendarMonthRound" size="1.2rem" />
        {{ $t("make-appointment") }}
      </div>
      <div
        v-for="(interestingLink, index) in interestingLinksButtons"
        :key="index"
        class="bg-white rounded-full text-center py-2 w-3/4 m-auto mt-10 shadow-lg flex items-center justify-center gap-2"
        @click="handleLinkClick(interestingLink.url)"
      >
        <c-icon name="OpenInNewFilled" size="1.2rem" />
        {{ interestingLink.title }}
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "./LoginForm.vue";
import CIcon from "../../../core-ui/src/components/CIcon.vue";
import { mapState } from "pinia";
import { authStore } from "@/stores/auth";

export default {
  name: "CustomerHub",
  data() {
    return {
      defaultButtons: [],
      showLogin: false,
      showAppointments: false,
    };
  },
  mounted() {
    if (this.organizationConfig.enableAppointments && this.currentLocation) {
      this.defaultButtons.push("appointments");
    }
    if (this.$route.query?.lastappUrl) {
      this.defaultButtons.push("login");
      this.defaultButtons.push("continueWithoutSignup");
    }
    if (this.currentCustomer?.id) {
      this.defaultButtons.push("download");
      this.defaultButtons.push("profile");
    } else {
      this.defaultButtons.push("signup");
    }
    if (
      this.interestingLinksButtons.length === 0 &&
      this.defaultButtons.length === 1 &&
      this.defaultButtons.includes("signup")
    ) {
      this.handleGoToCreateCustomer();
    }
    if (
      this.interestingLinksButtons.length === 0 &&
      this.defaultButtons.length === 1 &&
      this.defaultButtons.includes("download")
    ) {
      this.handleGoToDownload();
    }
  },
  computed: {
    ...mapState(authStore, [
      "interestingLinks",
      "branding",
      "organizationConfig",
      "currentLocation",
      "currentCustomer",
    ]),
    shouldShowEarnPoints() {
      return this.$route.query?.lastappUrl && !this.$route.query.signupOrLogin;
    },
    interestingLinksButtons() {
      return this.interestingLinks
        .filter((il) => il.showInSignup && il.url)
        .map((link) => ({
          title: link.title,
          url: link.url,
        }));
    },
  },
  methods: {
    handleLinkClick(url) {
      window.open(url, "_blank");
    },
    handleGoToDownload() {
      this.$router.push({
        name: "downloadPage",
        params: { ...this.$route.params },
      });
    },
    handleGoToProfile() {
      this.$router.push({
        name: "customerProfilePage",
        params: {
          shortenedSignupPageId: this.$route.params.shortenedSignupPageId,
        },
      });
    },
    handleGoToCreateCustomer() {
      this.$router.push({
        name: "createCustomerPage",
        params: { ...this.$route.params },
        query: {
          ...this.$route.query,
        },
      });
    },
    handleContinueWithoutSignup() {
      window.location = this.$route.query.lastappUrl;
    },
  },
  components: {
    LoginForm,
    CIcon,
  },
};
</script>
